import React from 'react'
import { PreviewLayout, PreviewBody, PreviewFooter } from '../sub-components/PreviewLayout'
import { BrandsPageType } from 'src/lib/types/uiPreview'
import LoadingList from '../skeletons/LoadingList'
import LoadingPhoneInput from '../skeletons/LoadingPhoneInput'
import PreviewCTA from '../sub-components/PreviewCTA'

const BrandsPage: React.FC<BrandsPageType> = ({
  brandLogoURL,
  colorPalette,
  loginButtonCTAText,
  marketingFlagConfig
}) => {
  return (
    <PreviewLayout logoUrl={brandLogoURL}>
      <>
        <PreviewBody>
          <LoadingList
            length={2}
            skeleton={{
              layout: 'row',
              config: [
                { height: 1, width: 1 },
                { height: 1, width: 6 }
              ]
            }}
          />
          <LoadingPhoneInput
            borderColor={colorPalette.primaryColor}
            skeleton={{
              layout: 'row',
              config: [
                {
                  height: 1.5,
                  width: 14
                }
              ]
            }}
          />
        </PreviewBody>
        <PreviewFooter>
          <PreviewCTA
            color={colorPalette.primaryColor ?? '#5a31f4'}
            textColor={colorPalette.primaryTextColor ?? '#FFFFFF'}
            CTAText={loginButtonCTAText}
            isSecuredByTextEnabled={true}
            isAnchored={false}
            marketingConsentText={
              marketingFlagConfig?.enableMarketingFlag ? marketingFlagConfig?.marketingConsentText : ''
            }
          />
        </PreviewFooter>
      </>
    </PreviewLayout>
  )
}

export default BrandsPage
